$('select[name="materialized_view[name_class_view]"]').on('change', ({ target }) => {
  const name_view = $(target).parents('.form-inputs').find('.materialized_view_name_view');
  target.value.match(/ApplicationRecord/) ? name_view.show() : name_view.hide();
})
